import React, { Component } from 'react';
import { connect } from 'react-redux'

class AddTrafficMarkerModal extends Component {
    constructor() {
        super()

        this.state = {
            lat: '',
            lng: '',
            errors: {}
        }
    }

    onChange = (event) => {

        const target = event.target;
        let value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    addMarker = () => {
        let { lat, lng } = this.state;
        const { trafficCoordinates } = this.props.state.coordinates
        lat = lat || trafficCoordinates.lat
        lng = lng || trafficCoordinates.lng

        let errors = {};

        const body = JSON.stringify({
            coordinates: [parseFloat(lat), parseFloat(lng)]
        })

        if (!lat || !lng) {
            errors.lat = "Объязательное поле";
            errors.lng = "Объязательное поле";
            this.setState({ errors });
        } else {
            fetch(`http://localhost:3000/traffic_markers`,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    }),
                    body: body
                }
            )
                .then((response) => {
                    return response.json()
                })
                .then((body) => {
                    let { trafficMarkers } = this.props.state.markers;
                    trafficMarkers = trafficMarkers.concat(body)

                    this.props.setTrafficMarkers(trafficMarkers)
                    this.setState({ lat: '', lng: ''})

                })
                .catch((err) => {
                    console.log('errooooooooorrrrrrrr ====== ' + err)
                })
        }
    }

    render() {
        const { trafficMarkerModal } = this.props.state.display;
        let { lat, lng, errors } = this.state;
        const { trafficCoordinates } = this.props.state.coordinates
        lat = lat || trafficCoordinates.lat
        lng = lng || trafficCoordinates.lng

        return (
            <div className="marker-modal-style">
                <div className="modal-content" style={{
                    display: trafficMarkerModal === 'none' ? 'none' : 'block'
                }}>

                    <div className="modal-header">

                        <button type="button"
                            className="close"
                            onClick={this.props.hideAddTrafficMarkerModal}>
                            &times;
                    </button>
                    </div>
                    <form>
                        <div className="modal-body form-group">
                            <span className="error-text">{errors.lat}</span>
                            <input
                                type="text"
                                name="lat"
                                onChange={this.onChange}
                                value={lat || ''}
                                className="form-control"
                                placeholder='Широта'
                                required
                            /><br />
                            <span className="error-text">{errors.lng}</span>
                            <input
                                type="text"
                                name="lng"
                                onChange={this.onChange}
                                value={lng || ''}
                                className="form-control"
                                placeholder='Долгота'
                                required
                            />
                            
                        </div>

                        <div className="modal-footer">
                            <button onClick={this.addMarker}
                                type="button" className="btn btn-success" >
                                Добавить
                        </button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}
export default connect(
    state => ({
        state
    }),
    dispatch => ({
        hideAddTrafficMarkerModal: () => {
            dispatch({ type: "HIDE_ADD_TRAFFIC_MARKER_MODAL" });
        },
        setTrafficMarkers: (value) => {
            dispatch({ type: "SET_TRAFFIC_MARKERS", value });
        }
    })
)(AddTrafficMarkerModal);
